<div class="button-card">
    <a finderLocale finderLinkId class="click-zone" href="{{ link }}" finderRouterLink [attr.aria-label]="ariaLabel">
        <finder-picture *ngIf="picture" class="image"
            aria-hidden="true"
            [picture]="picture">
        </finder-picture>
        <div class="button-details">
            <div class="title-container" [title]="title">
                <h4 class="title" [innerHTML]="title | safeHtml"></h4>
                <finder-font-icon name="next-2" *ngIf="link"></finder-font-icon>
            </div>
            <div class="copy" [innerHTML]="copy | safeHtml"></div>
        </div>
    </a>
</div>
